import {
  Sprite,
  Loader,
  Point,
  AnimatedSprite,
  BLEND_MODES,
} from 'pixi.js';
import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import store from '@/store';
import Actor from './Actor';
import vars from '../vars';

class Player extends Actor {
  constructor(parent) {
    super(parent);

    this.ref = new Sprite();
    this.bottom = new Sprite(Loader.shared.resources['images/PLAYER_BOTTOM'].texture);
    this.bottom.blendMode = BLEND_MODES.MULTIPLY;
    this.bottom.alpha = 0.85;
    const charId = store.state.characterId.toUpperCase();
    this.sprite = new AnimatedSprite(
      Object.values(
        Loader.shared.resources[`video/PLAYER_${charId}`].spritesheet.textures,
      ),
    );
    this.sprite.animationSpeed = 0.5;
    this.walkingArms = new AnimatedSprite(
      Object.values(
        Loader.shared.resources[`video/PLAYER_ARMS_WALK_${charId}`].spritesheet.textures,
      ),
    );
    this.walkingArms.animationSpeed = 0.5;
    this.shootingArms = new AnimatedSprite(
      Object.values(
        Loader.shared.resources[`video/PLAYER_ARMS_SHOOT_${charId}`].spritesheet.textures,
      ),
    );
    this.shootingArms.loop = false;
    this.playerLightBottom = new Sprite(Loader.shared.resources['images/PLAYER_LIGHT_BOTTOM'].texture);
    this.playerLightBottom.blendMode = BLEND_MODES.ADD;
    this.playerLightBottom.alpha = 0.6;
    this.playerLightUpper = new Sprite(Loader.shared.resources['images/PLAYER_LIGHT_UPPER'].texture);
    this.playerLightUpper.blendMode = BLEND_MODES.ADD;
    this.playerLightUpper.alpha = 0.3;
    this.ref.addChild(this.bottom);
    this.ref.addChild(this.playerLightBottom);
    this.ref.addChild(this.playerLightUpper);
    this.ref.addChild(this.walkingArms);
    this.ref.addChild(this.shootingArms);
    this.ref.addChild(this.sprite);

    this.resize();
    this.parent.ref.addChild(this.ref);

    this.sprite.renderable = false;
    this.walkingArms.renderable = false;
    this.shootingArms.renderable = false;

    this.fireRayHandler = () => this.fireRay();
    this.stopRayHandler = () => this.stopRay();
    eventHub.$on('fire-ray', this.fireRayHandler);
    eventHub.$on('stop-ray', this.stopRayHandler);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 1);
    this.sprite.position.y = vars.layout.STAGE_HEIGHT + 80;
    this.sprite.position.x = vars.layout.STAGE_WIDTH / 2;
    this.sprite.scale.x *= 1.1;
    this.sprite.scale.y *= 1.1;

    this.walkingArms.anchor = new Point(0.5, 1);
    this.walkingArms.position.y = vars.layout.STAGE_HEIGHT + 80;
    this.walkingArms.position.x = vars.layout.STAGE_WIDTH / 2;
    this.walkingArms.scale.x *= 1.1;
    this.walkingArms.scale.y *= 1.1;

    this.shootingArms.anchor = new Point(0.5, 1);
    this.shootingArms.position.y = vars.layout.STAGE_HEIGHT + 80;
    this.shootingArms.position.x = vars.layout.STAGE_WIDTH / 2;
    this.shootingArms.scale.x *= 1.1;
    this.shootingArms.scale.y *= 1.1;

    this.playerLightBottom.anchor = new Point(0.5, 0.5);
    this.playerLightBottom.position.x = vars.layout.STAGE_WIDTH / 2;
    this.playerLightBottom.position.y = vars.layout.STAGE_HEIGHT;
    this.playerLightBottom.scale.y = 1.5;
    this.playerLightUpper.anchor = new Point(0.5, 0.5);
    this.playerLightUpper.position.x = vars.layout.STAGE_WIDTH / 2;
    this.playerLightUpper.position.y = vars.layout.STAGE_HEIGHT;
    this.playerLightUpper.scale.y = 1.5;

    gsap.to(this.playerLightUpper.scale, {
      x: `+=${0.1}`,
      y: `+=${0.05}`,
      repeat: -1,
      yoyo: true,
      ease: 'power2.inOut',
      duration: 2,
    });

    this.bottom.anchor = new Point(0.5, 1);
    this.bottom.width = vars.layout.STAGE_WIDTH;
    this.bottom.position.y = vars.layout.STAGE_HEIGHT;
    this.bottom.position.x = vars.layout.STAGE_WIDTH / 2;
  }

  spawn() {
    this.sprite.renderable = true;
    this.walkingArms.renderable = true;
    this.sprite.play();
    this.walkingArms.play();
  }

  unspawn() {
    this.sprite.renderable = false;
    this.walkingArms.renderable = false;
  }

  fireRay() {
    this.shootingArms.renderable = true;
    this.walkingArms.renderable = false;
    this.shootingArms.play();
  }

  stopRay() {
    this.shootingArms.renderable = false;
    this.walkingArms.renderable = true;
    this.shootingArms.gotoAndStop(0);
  }

  destroy() {
    eventHub.$off('fire-ray', this.fireRayHandler);
    eventHub.$off('stop-ray', this.stopRayHandler);
    this.ref.destroy({ children: true });
  }
}

export default Player;
